// extracted by mini-css-extract-plugin
module.exports = {"restaurantsList":"RestaurantListPage_restaurantsList__3Jhv5"};